/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestQuranApps from "views/articles/BestQuranApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"

const AddAppollowToYourHomeScreenEN = ({ apps }: { apps: AppInterface[] }) => {
  const article = BestQuranApps["ar"]

  return (
    <InstantArticle {...article}>
      <div dir="rtl" style={{ textAlign: "justify" }}>
        <p>
          قراءة القرآن الكريم هي من ابرز العبادات في شهر رمضان المبارك بين
          المسلمين ومع كثرة الهواتف الذكية والاجهزة اللوحية أصبح الكثير من
          المسلمين يعتمدون على تطبيقات الايفون والايباد في قراءة القران الكريم
          وذلك بسبب المميزات التي توفرها تطبيقات القران الكريم مثل البحث عن
          الكلمات وتفسير الآيات ومعاني الكلمات والترجمة لاكثر من لغة والقراءة
          بصوت العديد من القراء المشهورين بالإضافة الى إمكانية حفظ الآية التي تم
          التوقف عنها لاستكمال القراءة فيما بعد. لذا جمعنا لكم في هذا المقال
          مختارات من افضل تطبيقات الايفون والايباد لقراءة القرآن الكريم
          والمتوفرة مجاناً في متجر البرامج.
        </p>

        <h2>Ayah</h2>
        <p>
          يجمع بين جمال التصميم وسهولة الاستخدام، الفائز بجائزة الكويت الدولية
          في دورتها الثامنة كأفضل تطبيق قرآن، من مزايا التطبيق:
        </p>
        <ol>
          <li>
            يتميز باعتماده لطبعة مجمع الملك فهد لطباعة المصحف الشريف بالمدينة
            المنورة لما تتمتع به من موثوقية وإتقان.
          </li>
          <li>
            مختصر في تفسير القرآن الكريم المتميز بسهولة عبارته، مع ما فيه من
            بيان مختصر لمقاصد السور، واستنباط لأبرز هدايات الآيات، وبيان لمعاني
            المفردات الغريبة بلون مميز.
          </li>
          <li>
            مقاطع صوتية لنخبة من القراء المميزين مع دعم كامل للتحكم بالتلاوة من
            قفل الشاشة، وعدد مرات الترديد، ومؤقت الإيقاف.
          </li>
          <li>
            بحث سريع ومتقدم، يجمع بين البحث في الآيات وأسماء السور، وحتى
            الانتقال السريع بأرقام الصفحات.
          </li>
          <li>
            مشاركة آية أو عدة آيات عبر الشبكات الاجتماعية نصًا أو صورة بإخراج
            جميل ومميز.
          </li>
          <li>
            الفاصل القرآني هو علامة تنتقل معك من آية إلى أخرى ليعينك على متابعة
            ختمتك القرآنية.
          </li>
          <li>
            تدوين ملاحظاتك وتأملاتك أثناء التلاوة واستعرضها جميعًا بشكل جميل
            ومتسلسل، مع تنسيق تلقائي للملاحظات أثناء كتابتها.
          </li>
          <li>ميّز أي آية بنجمة للوصول السريع إليها لاحقًا.</li>
          <li>فوائد قرآنية متجددة مع كل زيارة للتطبيق.</li>
          <li>خلفية داكنة لقراءة أكثر راحة في الليل.</li>
        </ol>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 706037876)} />
        </div>
        <h2>تطبيق القرآن الكريم</h2>
        <p>
          من اهم مميزات البرنامج:
          <ol>
            <li>
              التفاعل مع نص القرآن بالخط العثماني على مستوى الآية مما يتيح
              للمستخدم التفاعل مع آيات المصحف بدلا عن صفحاته.
            </li>
            <li>
              ميزة الإستماع للآيات مع إمكانية التكرار أو الإعادة في منتصف الآية
              المسموعة. كما يوفر البرنامج العديد من المقرئين ليتمكن المستمع من
              تنزيل أي من المقرئين عند الحاجة.
            </li>
            <li>
              إدراج نظام مميز لحفظ مواقع القراءة بحيث يتمكن القارئي من تحديد
              الآية وحفظها للرجوع لها. كما يتيح البرنامج للمستخدم أكثر من مؤشر
              للعودة بألوان مختلفة تسمح له بتعدد الختمات والقراءات بصورة ميسرة
              وجميلة.
            </li>
            <li>
              يوفر البرنامج للقارئ إمكانية الرجوع لتفسير أو ترجمة أي آية بصورة
              لحظية من خلال إختيار الآية على صفحات المصحف.
            </li>
            <li>
              يعرض البرنامج خلفية الصفحات بألوان متعددة تتيح للقارئ إختيار اللون
              المريح بالنسبة له. كما يتيح البرنامج للقارئ القراءة الليلية والتي
              تلون الخلفية باللون الأسود والخطوط البيضاء لتعطي القارئ الراحة
              التامة عند القراءة في أجواء منخفضة الإضائة.
            </li>
            <li>
              يقدم البرنامج للمستخدم تقرير بعدد ما قرأه من آيات وصفحات وسور كما
              يحسب الزمن المستغرق لتلك القراءة.
            </li>
            <li>
              ييسر البرنامج خاصية البحث النصي في آيات القرآن من خلال البحث
              اللحظي وعرض النتائج مع الصفحات بالإضافة إلى إمكانية الذهاب للصفحة
              وتظليل خلفية الآية المختارة ليسهل على المستخدم معرفتها.
            </li>
            <li>
              يوفر البرنامج العديد من المميزات الأخرى التي تساعد على القراءة
              السهلة والميسرة والتي قد تم تصميمها من قبل مصممين محترفين حازوا
              على جوائز عالمية في مجال تصميم واجهات المستخدم.
            </li>
          </ol>
        </p>

        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 385990290)} />
        </div>
        <h2>مصحف آي-فون إسلام</h2>
        <p>
          يعد مصحف آيفون اسلام من اول التطبيقات العربية والعالمية التي قدمت
          تجربة رائعة اثناء قراءة المصحف الشريف مع محاكات تآثير الورق الحقيقي
          عند قلب الصفحات في التطبيق، بالاضافة الى العديد من المزايا المشتركة
          بينه وبين التطبيقات السابق ذكرها يتميز مصحف آي-فون اسلام بالحرية في
          اختيار المصحف والتفاسير والقرّاء المفضلين، يمكنك تغيير المصحف ضمن
          التطبيق حيث يحتوي على مجموعة من المصاحف بعدة روايات. يمكن مراجعة
          المقال الكامل عن التطبيق من موقع آي-يفون اسلام من خلال الرابط التالي:
        </p>
        <ul>
          <li>
            <a href="https://iphoneislam.com/2014/08/why-iphoneislam-mushaf/38269">
              مصحف آي-فون اسلام الجديد
            </a>
          </li>
        </ul>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 328962407)} />
        </div>

        <br />
        <div className="card mt-4 mb-1">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              هل لديك أي تطبيقات مفضلة لتلاوة وتدبر القرآن الكريم على الآيفون
              والآيباد؟ يمكنك مشاركة تطبيقاتك المفضلة من خلال{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  صفحة النشر
                </span>
              </Link>
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenEN
